import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { FileRecord } from '../types/file-record';
import queryClient from '../query-client';

type MakeOriginalFilesRequest = {
    ids: string[];
};

async function makeRefernecesOriginal({ ids }: MakeOriginalFilesRequest): Promise<FileRecord[]> {
    const { data } = await api.post('/file-records/references/original', {
        ids,
    });
    return data;
}

export function useMakeReferencesOriginal(): UseMutationResult<FileRecord[], unknown, MakeOriginalFilesRequest, unknown> {
    return useMutation(makeRefernecesOriginal, {
        onSettled: () => {
            queryClient.invalidateQueries(['file-records']);
        },
    });
}
